<script setup lang="ts">
import list from './components/list.vue'
import gridChart from './components/gridChart.vue'
import { useUnitStore } from '@/store/modules/unit';
const unitStore = useUnitStore();
import { getUnitList } from '@/api/modules/home'

definePage({
  name: 'selected',
  meta: {
    title: '自选',
  },
})


const tabs=unitStore.unitInfo
const num = ref(0)
const type=ref(0)
const onClickTab = ({ name }: {name:number}) => {
  num.value =name
   type.value=tabs[name].type
}

const showBtn=ref(false)

async function onLoad() {
  // 异步更新数据
      const { status, data } = await getUnitList({
      page: 1,
      // hold: cardActive.value,
      type:Number(num.value),
    })
    if (status === 1) {
      console.log('获取数据');

        showBtn.value=!!data.list.length
    }

  }

  watch(()=>num.value,()=>{
onLoad()
  })

  onMounted(()=>{
    onLoad()
  })

const router = useRouter()

const goSet = () => {
  router.push('/class-set')
}

const toSearch=()=>{
  router.push({name:'add-list',query:{id:type.value}})
}

const toAdd=()=>{
  router.push({name:'add-list',query:{id:type.value}})
}

const toEdit=()=>{
  router.push({name:'edit-list',query:{id:type.value}})
}

const hengsheng = ref([
  {
    name: '恒生指数',
    num: 26345.63,
    add: 707.93,
    per: '+2.76%',
    data: '1408.64亿'
  },
  {
    name: '恒生国企',
    num: 9172.83,
    add: 255.31,
    per: '+2.86%',
    data: '522.44亿'
  },
  {
    name: '恒生科技',
    num: 5736.44,
    add: 220.46,
    per: '+4.00%',
    data: '439.63亿'
  },
])

const show = ref(false)
const active = ref(0)
const showAction = () => {
  show.value = !show.value
}

const stocks = ref([
  {
    id: 1,
    name: '恒生指数',
    data: {
      currentPrice: '26338.47', change: 707.93, changePercent: 2.76,
      volume: '1408.64亿', volumes: '44.41亿股',
      high: 26345.63, low: 25717.42, open: 25717.42, close: 25630.54,
      times: ['09:30', '09:35', '09:40', '09:45', '09:50', '09:55', '10:00', '10:05', '10:10', '10:15', '10:20', '10:25', '10:30', '10:35', '10:40', '10:45', '10:50', '10:55', '11:00', '11:05', '11:10', '11:15', '11:20', '11:25', '11:30', '12:00', '13:00', '13:05', '13:10', '13:15', '13:20', '13:25', '13:30', '13:35', '13:40', '13:45', '13:50', '13:55', '14:00', '14:05', '14:10', '14:15', '14:20', '14:25', '14:30', '14:35', '14:40', '14:45', '14:50', '14:55', '15:00', '15:05', '15:10', '15:15', '15:20', '15:25', '15:30', '15:35', '15:40', '15:45', '15:50', '15:55', '16:00'],
      // 波动逻辑：25700 -> 26100 -> 25800 (跳水) -> 26300 (反转)
      seriesData: [25717, 25780, 25850, 25940, 26020, 26100, 26150, 26120, 26080, 26030, 25950, 25880, 25820, 25850, 25900, 25980, 26050, 26120, 26180, 26220, 26250, 26200, 26150, 26100, 26050, 26080, 26120, 26150, 26100, 26040, 25980, 26020, 26080, 26150, 26210, 26260, 26280, 26250, 26210, 26180, 26220, 26270, 26310, 26330, 26310, 26280, 26260, 26290, 26320, 26340, 26310, 26280, 26300, 26325, 26335, 26345, 26330, 26320, 26335, 26342, 26338, 26338, 26338],
      avgData: [25717, 25730, 25760, 25800, 25850, 25900, 25930, 25940, 25950, 25940, 25920, 25900, 25880, 25885, 25895, 25910, 25940, 25970, 26010, 26040, 26070, 26085, 26095, 26105, 26110, 26115, 26125, 26135, 26140, 26142, 26145, 26150, 26155, 26165, 26175, 26185, 26195, 26200, 26205, 26210, 26220, 26230, 26245, 26260, 26270, 26280, 26285, 26295, 26305, 26310, 26315, 26318, 26322, 26325, 26328, 26330, 26332, 26333, 26334, 26335, 26336, 26337, 26338],
      volumeData: [280, 150, 190, 240, 310, 450, 520, 380, 210, 190, 480, 550, 320, 210, 180, 240, 360, 420, 580, 610, 450, 320, 210, 190, 150, 280, 340, 410, 380, 310, 450, 520, 480, 390, 450, 580, 620, 340, 220, 280, 410, 530, 640, 710, 520, 380, 420, 580, 630, 850, 720, 540, 480, 620, 780, 950, 820, 650, 520, 480, 560, 720, 850]
    }
  },
  {
    id: 2,
    name: '恒生国企',
    data: {
      currentPrice: '9168.99', change: 255.31, changePercent: 2.86,
      volume: '522.44亿', volumes: '35.50亿股',
      high: 9172.83, low: 8941.75, open: 8949.76, close: 8913.68,
      times: ['09:30', '09:35', '09:40', '09:45', '09:50', '09:55', '10:00', '10:05', '10:10', '10:15', '10:20', '10:25', '10:30', '10:35', '10:40', '10:45', '10:50', '10:55', '11:00', '11:05', '11:10', '11:15', '11:20', '11:25', '11:30', '12:00', '13:00', '13:05', '13:10', '13:15', '13:20', '13:25', '13:30', '13:35', '13:40', '13:45', '13:50', '13:55', '14:00', '14:05', '14:10', '14:15', '14:20', '14:25', '14:30', '14:35', '14:40', '14:45', '14:50', '14:55', '15:00', '15:05', '15:10', '15:15', '15:20', '15:25', '15:30', '15:35', '15:40', '15:45', '15:50', '15:55', '16:00'],
      // 波动逻辑：锯齿形上升
      seriesData: [8949, 8930, 8960, 8940, 8980, 9010, 8990, 9025, 9050, 9030, 9060, 9090, 9070, 9100, 9080, 9110, 9130, 9115, 9140, 9160, 9145, 9120, 9090, 9110, 9135, 9150, 9165, 9140, 9120, 9145, 9170, 9155, 9130, 9110, 9135, 9160, 9145, 9130, 9155, 9170, 9158, 9145, 9162, 9172, 9160, 9150, 9165, 9170, 9162, 9158, 9165, 9170, 9164, 9160, 9165, 9170, 9168, 9165, 9168, 9170, 9168, 9168, 9168],
      avgData: [8949, 8940, 8945, 8948, 8955, 8965, 8975, 8985, 8995, 9005, 9015, 9025, 9035, 9045, 9055, 9065, 9075, 9085, 9095, 9105, 9112, 9115, 9110, 9112, 9118, 9125, 9135, 9138, 9135, 9138, 9145, 9148, 9145, 9142, 9145, 9148, 9150, 9152, 9155, 9158, 9160, 9161, 9162, 9164, 9165, 9165, 9166, 9167, 9167, 9167, 9168, 9168, 9168, 9168, 9168, 9168, 9168, 9168, 9168, 9168, 9168, 9168, 9168],
      volumeData: [150, 280, 140, 310, 420, 190, 360, 450, 210, 520, 630, 340, 410, 580, 290, 420, 510, 380, 450, 620, 340, 210, 450, 580, 650, 420, 310, 280, 420, 530, 680, 420, 310, 480, 620, 750, 530, 310, 420, 580, 630, 410, 520, 780, 850, 620, 480, 520, 680, 750, 820, 530, 410, 520, 680, 750, 880, 920, 750, 620, 580, 650, 850]
    }
  },
  {
    id: 3,
    name: '恒生科技',
    data: {
      currentPrice: '5736.44', change: 220.46, changePercent: 4.00,
      volume: '439.62亿', volumes: '26.58亿股',
      high: 5753.28, low: 5530.99, open: 5547.85, close: '5515.98',
      times: ['09:30', '09:35', '09:40', '09:45', '09:50', '09:55', '10:00', '10:05', '10:10', '10:15', '10:20', '10:25', '10:30', '10:35', '10:40', '10:45', '10:50', '10:55', '11:00', '11:05', '11:10', '11:15', '11:20', '11:25', '11:30', '12:00', '13:00', '13:05', '13:10', '13:15', '13:20', '13:25', '13:30', '13:35', '13:40', '13:45', '13:50', '13:55', '14:00', '14:05', '14:10', '14:15', '14:20', '14:25', '14:30', '14:35', '14:40', '14:45', '14:50', '14:55', '15:00', '15:05', '15:10', '15:15', '15:20', '15:25', '15:30', '15:35', '15:40', '15:45', '15:50', '15:55', '16:00'],
      // 波动逻辑：宽幅震荡，多次急拉急跌
      seriesData: [5547, 5510, 5560, 5520, 5590, 5640, 5600, 5670, 5720, 5650, 5710, 5760, 5700, 5640, 5680, 5620, 5580, 5630, 5690, 5740, 5700, 5650, 5610, 5660, 5720, 5770, 5720, 5650, 5680, 5730, 5780, 5710, 5640, 5600, 5650, 5710, 5760, 5700, 5660, 5710, 5750, 5780, 5740, 5700, 5670, 5720, 5760, 5790, 5810, 5760, 5720, 5750, 5780, 5800, 5760, 5780, 5810, 5830, 5780, 5750, 5770, 5750, 5736],
      avgData: [5547, 5530, 5540, 5535, 5545, 5560, 5575, 5595, 5615, 5625, 5635, 5655, 5665, 5660, 5665, 5655, 5645, 5642, 5648, 5658, 5668, 5670, 5665, 5662, 5670, 5685, 5695, 5698, 5695, 5700, 5710, 5715, 5710, 5700, 5695, 5700, 5708, 5715, 5718, 5722, 5728, 5735, 5740, 5742, 5740, 5738, 5742, 5748, 5755, 5760, 5758, 5755, 5758, 5762, 5765, 5768, 5772, 5775, 5775, 5770, 5765, 5755, 5736],
      volumeData: [450, 320, 580, 410, 620, 750, 530, 680, 850, 620, 710, 920, 580, 420, 560, 680, 750, 520, 640, 810, 580, 420, 380, 560, 720, 880, 650, 510, 620, 780, 950, 720, 540, 480, 620, 780, 950, 720, 540, 650, 820, 980, 750, 610, 520, 740, 880, 950, 1100, 820, 650, 780, 920, 1050, 850, 920, 1100, 1200, 950, 820, 880, 720, 850]
    }
  }
]);
</script>

<template>
  <FmPageLayout navbar tabbar>
    <template #navbar-end>
      <FmIcon name="tdesign:search" class="text-18px color-[#fff]" @click="toSearch"/>
    </template>
    <van-tabs v-model:active="num" @click-tab="onClickTab" class="p-r-27px " background="#F1F2F7"
      title-active-color="#111E36" line-width="9px" >
      <van-tab v-for="(item, i) in tabs" :title="item.name" :key="i" />
      <FmIcon name="tdesign:format-vertical-align-right" class="absolute right-0 top-[50%] translate-[0,-50%]"
        @click="goSet" />
    </van-tabs>
    <div class="bg-[#FFFFFF] flex-auto m-t-9px m-b-16px">
       <list v-model:id="num" v-if="showBtn"></list>
      <div v-if="!showBtn" class="flex justify-center items-center h-[100%]">
        <div class="flex flex-col items-center">
          <!-- <FmIcon name="select" class="text-[100px]" /> -->
          <img width="100" src="@/assets/images/select.png"></img>
          <van-button plain type="primary" class="btn color-[#3C78FF]  m-t-35px h-[36px] w-[148px]"  @click="toAdd">
            <FmIcon name="tdesign:add" class="text-[18px] align-sub"/>
            添加自选
          </van-button>
        </div>
      </div>
      <div v-else>
        <!-- <list v-model:id="num"></list> -->
        <div class="btns flex justify-between m-l-16px m-r-16px">
          <van-button plain type="primary" class="btn color-[#3C78FF]  m-t-16px h-[36px] w-[148px]"  @click="toAdd">
            <FmIcon name="tdesign:add" class="text-[22px] align-sub"/>
            添加自选
          </van-button>
          <van-button plain type="primary" class="btn color-[#3C78FF]  m-t-16px h-[36px] w-[148px]" @click="toEdit">
            <FmIcon name="tdesign:edit-2" class="text-[22px] align-sub" />
            编辑自选
          </van-button>
        </div>
      </div>
    </div>
    <div class="absolute bottom-[16px] w-[100%]  border border-t-[#E4E5E9] border-b-0 overflow-hidden h-[30px]">
      <van-swipe class="my-swipe border-t-[#E4E5E9]" :autoplay="5000" :show-indicators="false" vertical height="30">
        <div v-for="(item, i) in hengsheng" :key="i">
          <van-swipe-item class="flex p-l-8px p-r-8px items-center  text-14px">
            <div class="w-[20%] color-[#333333] text-16px font-500">{{ item.name }}</div>
            <div class="w-[20%] color-[#22A875]">{{ item.num }}</div>
            <div class="w-[17%] color-[#22A875]">{{ item.add }}</div>
            <div class="w-[18%] color-[#22A875] text-left ">{{ item.per }}</div>
            <div class="w-[20%] color-[#333333] font-500">{{ item.data }} </div>
            <FmIcon name="tdesign:chevron-up" class="text-16px" @click="showAction" />
          </van-swipe-item>
        </div>
      </van-swipe>
    </div>

    <van-action-sheet v-model:show="show" :round="false" :closeable="false" class="bottom-60px" :overlay="false">
      <van-tabs v-model:active="active"  line-width="9px" >
        <!-- <van-tab title="恒生指数"></van-tab>
        <van-tab title="恒生国企"></van-tab>
        <van-tab title="恒生科技">
          <template #title>
            <div class="custom-title">
              <span>恒生科技</span>
              <FmIcon name="tdesign:chevron-down" class="text-20px absolute right-0" @click="showAction" />
            </div>
          </template>
        </van-tab> -->
        <van-tab v-for="stock in stocks" :key="stock.id" :title="stock.name">
          <gridChart :chartData="stock.data" theme="dark" />
          <template #title v-if="stock.id===3">
            <div class="custom-title">
              <span>恒生科技</span>
              <FmIcon name="tdesign:chevron-down" class="text-20px absolute right-0" @click="showAction" />
            </div>
          </template>
        </van-tab>
      </van-tabs>
      <!-- <gridChart /> -->

    </van-action-sheet>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.btn {
  line-height: 36px;
  vertical-align: middle;
  border: 2px solid #3c78ff;
  border-radius: 18px;
}

:deep(.van-tabs__nav) {
  background-color: #f1f2f7;
}

:deep(.van-tab--active) {
  font-size: 17px;
}

.btns {
  .btn {
    font-size: 17px;
  }
}
</style>
